/**
 * Normalize event image URLs from scrapers / legacy DB rows.
 * getINVOLVED (Campus Labs) imagePath must be loaded from se-images.campuslabs.com;
 * relative filenames resolve against the Next.js origin (e.g. localhost:3000/filename.png).
 */
const CAMPUSLABS_CLINK = 'https://se-images.campuslabs.com/clink/images';

export function resolveEventImageUrl(url: string | null | undefined): string | null {
  if (url == null || typeof url !== 'string') return null;
  const u = url.trim();
  if (!u) return null;

  if (u.startsWith('https://') || u.startsWith('http://')) {
    try {
      const parsed = new URL(u);
      const host = parsed.hostname;
      if (host === 'localhost' || host === '127.0.0.1') {
        const last = parsed.pathname.split('/').filter(Boolean).pop();
        if (last && /\.(png|jpe?g|webp|gif)$/i.test(last)) {
          return `${CAMPUSLABS_CLINK}/${last}`;
        }
      }
    } catch {
      return u;
    }
    return u;
  }

  return `${CAMPUSLABS_CLINK}/${u.replace(/^\//, '')}`;
}
